import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified || user.role === "admin") return null;
  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Verification email sent — check your inbox");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="email-verification-banner"
      className="border-y border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/30 px-4 py-2.5 text-sm">
      <div className="mx-auto max-w-7xl flex flex-col sm:flex-row gap-3 items-start sm:items-center">
        <MailWarning className="w-5 h-5 text-amber-700 dark:text-amber-300 flex-shrink-0" />
        <p className="text-amber-900 dark:text-amber-100 flex-1">
          <b>Verify your email</b> to unlock financial actions — listing notes, making offers, submitting loan
          applications, creating pre-approvals, or registering a dealership.
        </p>
        <Button size="sm" variant="outline" className="rounded-none uppercase text-xs tracking-wider"
          disabled={busy} onClick={resend} data-testid="resend-verification-btn">
          {busy ? "Sending…" : "Resend Email"}
        </Button>
      </div>
    </div>
  );
}
